<template>
  <div class="bg-white">
    <CollectMinimizationFilter id="sidebar-collect-minimization-filter" @apply="paginate" />

    <div style="max-height:100vh;overflow-x: auto;" class="p-1">
      <div v-if="!isLoading && pagination">
        <b-row class="font-size-11  mt-0 bg-soft-secondary sticky-header">
          <b-col md="1" class="bg-secondary text-white  sticky sticky-col-1">
            {{ $t("department.text") }}
          </b-col>
          <b-col md="11">
            <b-row>
              <b-col md="1" class="border-left bg-secondary text-white  sticky sticky-col-2"> {{ $t("process.text") }} </b-col>
              <b-col md="11">
                <b-row>
                  <b-col md="4" class="border-left   bg-secondary text-white  sticky sticky-col-3">
                    {{ $t("datasource.text") }}
                  </b-col>
                  <b-col md="8">
                    <b-row>
                      <b-col md="2" class="border-left  sticky sticky-col-4">
                        {{ $t("data-category.text") }}
                      </b-col>
                      <b-col md="10" class="border-left">
                        <b-row>
                          <b-col md="8" class="border-left">
                            {{ $t("data.text") }}
                          </b-col>
                          <b-col md="4" class="border-left">
                            {{ $t("datasubject.text") }}
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <!---->

        <b-row v-for="department in pagination.docs" :key="department._id" class="topLevel">
          <b-col md="1" :id="department._id" class="sticky-col sticky-col-1">
            <div class="p-2 stickyValue">
              {{ department.name | translate }}
            </div>
          </b-col>
          <b-col md="11">
            <b-row v-for="process in department.processes" :key="process._id">
              <b-col md="1" :id="process._id" :parent="department._id" class="sticky-col sticky-col-2">
                <div class="p-2 stickyValue">
                  {{ process.name | translate }}
                </div>
              </b-col>
              <b-col md="11">
                <b-row v-for="datasource in process.datasources" :key="datasource._id">
                  <b-col md="4" :id="datasource._id" :parent="process._id" class="sticky-col sticky-col-3">
                    <div class="p-2 stickyValue">
                      <b> {{ datasource.name | translate }}</b>
                      <datasource-collect-minimization-status :department="department" :process="process" :datasource="datasource" @onSave="paginate()" />
                    </div>
                  </b-col>
                  <b-col md="8">
                    <b-row v-for="category in datasource.categories" :key="category._id">
                      <b-col md="2" :id="category.combinedId" level="category" :datasource="datasource._id" :parent="datasource._id" class="sticky-col sticky-col-4">
                        <div class="p-2 stickyValue">
                          {{ category.name | translate }}
                        </div>
                      </b-col>

                      <b-col md="10">
                        <b-row v-for="data in category.datas" :key="data._id">
                          <b-col md="8" :id="data._id" :datasource="datasource._id" :data="data._id" :parent="category.combinedId" class="p-2">
                            <b> {{ data.name | translate }}</b>
                            <data-collect-minimization-status :department="department" :process="process" :data="data" :datasource="datasource" @onSave="paginate()" />
                          </b-col>
                          <b-col md="4">
                            <b-row v-for="datasubject in data.datasubjects" :key="datasubject._id">
                              <b-col md="12" :id="datasubject._id" :datasource="datasource._id" :data="data._id" :parent="data._id" level="datasubject">
                                {{ datasubject.name | translate }}
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("department.no-department") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="20" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import DataCollectMinimizationStatus from "./component/data-collect-minimization-status";
import DatasourceCollectMinimizationStatus from "./component/datasource-collect-minimization-status";
import CollectMinimizationFilter from "./component/filter/collect-minimization-filter";

export default {
  components: { CollectMinimizationFilter, DataCollectMinimizationStatus, DatasourceCollectMinimizationStatus },
  data() {
    return {
      hoveredItem: null,
      request: {
        options: { page: 1, limit: 50, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  computed: {
    pagination() {
      return this.$store.getters["minimization/collectPagination"];
    },
    isLoading() {
      return this.$store.getters["minimization/isCollectMinimizationLoading"];
    },

    criteria() {
      return this.$store.getters["collectMinimizationFilter/criteria"];
    },
    hasFilter() {
      return Object.keys(this.criteria).find((i) => !!this.criteria[i]);
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
  },

  mounted() {},
  methods: {
    async paginate() {
      try {
        const request = { pagination: this.request };
        if (this.hasFilter) {
          request.criteria = this.criteria;
        }

        await this.$store.dispatch("minimization/fetchCollectMinimization", request);
        this.initHover();
      } catch (error) {}
    },

    initHover() {
      const divs = document.querySelectorAll(".topLevel *");
      divs.forEach((b) => {
        b.addEventListener("mouseover", (e) => {
          document.querySelectorAll(".highlight").forEach((i) => i.classList.remove("highlight"));
          let el = e.target;
          if (!el.attributes["parent"]) {
            el = el.closest("[parent]");
          }
          if (!el) {
            return;
          }
          let parentId = el.attributes["parent"].value;

          [
            ...(el.attributes["level"]?.value == "category" ? [] : document.querySelectorAll("[datasource='" + parentId + "']")),
            ...(el.attributes["level"]?.value == "datasubject" ? [] : document.querySelectorAll("[data='" + parentId + "']")),
            ...document.querySelectorAll("[datasubject='" + parentId + "']"),
          ].forEach((i) => i.classList.add("highlight"));

          el.classList.add("highlight");
          let parent = document.querySelector("[id='" + parentId + "']");
          while (parent) {
            parent.classList.add("highlight");
            parent = document.querySelector("[id='" + parent.attributes["parent"]?.value + "']");
          }
        });
        b.addEventListener("mouseleave", (e) => {
          document.querySelectorAll(".highlight").forEach((i) => i.classList.remove("highlight"));
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.border-light {
  border: 0.01em solid rgb(144, 144, 144) !important;
}

.topLevel div {
  font-size: 10px;
}

.topLevel .row > div:nth-child(1):not(.sub-table div):not(.sub-inventory div) {
  // border: 0.01em solid rgb(221 221 221);
  box-shadow: 1px 0 0 0 rgb(221 221 221), 0 1px 0 0 rgb(221 221 221), 1px 1px 0 0 rgb(221 221 221), /* Just to fix the corner */ 1px 0 0 0 rgb(221 221 221) inset,
    0 1px 0 0 rgb(221 221 221) inset;
}

.topLevel {
  border-bottom: 1px solid rgb(221 221 221);
}

.sub-table table {
  min-width: 200px;
}

.sub-table table td,
.sub-table table th {
  padding: 4px !important;
}

.sub-inventory div {
  // border: 0.01em solid rgb(234, 234, 234);
  box-shadow: 1px 0 0 0 rgb(221 221 221), 0 1px 0 0 rgb(221 221 221), 1px 1px 0 0 rgb(221 221 221), /* Just to fix the corner */ 1px 0 0 0 rgb(221 221 221) inset,
    0 1px 0 0 rgb(221 221 221) inset;
}

.highlight {
  background-color: rgb(246, 251, 255) !important;
}
.highlight-dark {
  background-color: rgb(233, 246, 255) !important;
}

.sticky,
.sticky-col {
  width: 150px;
  position: sticky;
  z-index: 1;
  box-shadow: 1px 0 0 0 rgb(221 221 221), 0 1px 0 0 rgb(221 221 221), 1px 1px 0 0 rgb(221 221 221), /* Just to fix the corner */ 1px 0 0 0 rgb(221 221 221) inset,
    0 1px 0 0 rgb(221 221 221) inset;

  .stickyValue {
    position: sticky;
    top: 20px;
  }

  // div {
  //   white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  // }
}

.sticky-col {
  background-color: white;
}

.sticky-col-1 {
  left: 0px;
}

.sticky-col-2 {
  left: 70px;
}

.sticky-col-3 {
  left: 140px;
}

.sticky-col-4 {
  left: 200px;
}

.sticky-col-5 {
  left: 260px;
}

.sticky-col-6 {
  left: 400px;
}

.bg-soft-inventory {
  background-color: rgb(240, 229, 253);
}

.bg-inventory {
  background-color: rgb(228, 206, 255);
}

.bg-soft-secondary {
  background-color: rgb(222, 222, 222) !important;
}

.sticky-header {
  position: sticky;
  top: -4px;
  z-index: 2;
}

.sticky-header-fs {
  position: sticky;
  top: -4px;
  z-index: 2;
}

.col ul {
  padding-left: 15px;
  margin: 0px;
}
</style>
